import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import { Button, Icon, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import MaterialDatePicker from '../../../components/global/form/MaterialDatePicker';
import { Trim } from '../../../common/util';
import apiService from '../../../services.js/apiService';
import OverLoading from '../../../components/global/OverLoading';
import { IsEmpty } from '../../../common/checks';
import colours from '../../../styles/colours';

const GiveawayWinnerAdd = (props) => {
  const [formData, setFormData] = useState({
    shopperId:       '',
    giveawayEntryId: '',
    name:            '',
    mobile:          '',
    prizeSentDate:   new Date(),
    winDate:         new Date(),
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const giveawayWinnerId = props.match.params.id;
  const history = useHistory();

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onChangeDate = (e = new Date(), name) => {
    setFormData({ ...formData, [name]: e });
  };

  const fetchData = async () => {
    if (giveawayWinnerId) {
      try {
        const giveawayWinnerData = await apiService.getGiveAwayWinner(giveawayWinnerId);
        if (!IsEmpty(giveawayWinnerData)) {
          // format dates from db to sg tz
          const formattedGiveawayWinnerData = {
            ...giveawayWinnerData,
            winDate:       moment(giveawayWinnerData.winDate).utc(+8, false).toDate(),
            prizeSentDate: moment(giveawayWinnerData.prizeSentDate).utc(+8, false).toDate(),
          };
          setFormData(formattedGiveawayWinnerData);
        }
      } catch (err) {
        toast.error(err.message);
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, [giveawayWinnerId]);

  const onSubmit = async (e) => {
    e.preventDefault();
    e.persist();
    const curError = {};
    const setToBlank = {};
    let isAllValid = true;

    for (const key in formData) {
      if (key === 'id' || key === 'prizeSentDate' || key === 'winDate' || key === 'shopperId') {
        continue;
      }

      if (Trim(formData[key]) === '' || IsEmpty(formData[key])) {
        curError[key] = `This field not allowed to be empty`;
        setToBlank[key] = '';
        isAllValid = false;
      } else {
        curError[key] = '';
      }
    }

    setErrors({ ...curError });

    if (!isAllValid) {
      return;
    }

    // formDate to send backend
    const formattedFormData = {
      ...formData,
      winDate:       new Date(`${formData.winDate.getFullYear()}-${formData.winDate.getMonth() + 1}-${formData.winDate.getDate()} 00:00:00 +8:00`),
      prizeSentDate: new Date(`${formData.prizeSentDate.getFullYear()}-${formData.prizeSentDate.getMonth() + 1}-${formData.prizeSentDate.getDate()} 00:00:00 +8:00`),
    };

    if (giveawayWinnerId) {
      setLoading(true);
      try {
        await apiService.updateGiveAwayWinner(giveawayWinnerId, formattedFormData);
        toast.success('Update giveaway winner success');
        history.replace(`/admin/mobileApp/giveawayWinner`);
      } catch (err) {
        toast.error(err.message);
      }
      setLoading(false);
    } else {
      setLoading(true);
      try {
        await apiService.addGiveAwayWinner(formattedFormData);
        toast.success('Create giveaway winner success');
        history.replace(`/admin/mobileApp/giveawayWinner`);
      } catch (err) {
        toast.error(err.message);
      }
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="content-header d-flex align-items-center justify-content-start py-3">
        <Button onClick={() => { history.replace('/admin/mobileApp/giveawayWinner'); }} size="large" className="ml-0">
          <Icon fontSize="large">arrow_back</Icon>
        </Button>
        <Typography variant="h4" style={{ fontWeight: 'bold' }}>{`${giveawayWinnerId ? 'Update' : 'Add'} Giveaway winner`}</Typography>
      </div>
      <form
        className="form position-relative px-4"
        onSubmit={(e) => onSubmit(e)}
        autoComplete="off"
      >
        {loading && <OverLoading />}
        <div className="row">
          <div className="col-lg-6 col-sm-12 form-section">
            <div className="form-group">
              <Typography variant="h6">Giveaway Entry Id *</Typography>
              <input
                type="text"
                className="form-control"
                name="giveawayEntryId"
                id="Giveaway Entry Id"
                value={formData.giveawayEntryId || ''}
                onChange={(e) => onChange(e)}
                required
              />
              <span style={{ color: colours.Red }}>{errors.giveawayEntryId}</span>
            </div>
            <div className="form-group">
              <Typography variant="h6">Shopper Id *</Typography>
              <input
                type="number"
                className="form-control"
                min="1"
                name="shopperId"
                id="Shooper Id"
                value={formData.shopperId || ''}
                onChange={(e) => onChange(e)}
                required
              />
              <span style={{ color: colours.Red }}>{errors.shopperId}</span>
            </div>
            <div className="form-group">
              <Typography variant="h6">Name *</Typography>
              <input
                type="text"
                className="form-control"
                name="name"
                id="name"
                value={formData.name || ''}
                onChange={(e) => onChange(e)}
                required
              />
              <span style={{ color: colours.Red }}>{errors.name}</span>
            </div>
            <div className="form-group">
              <Typography variant="h6">Mobile *</Typography>
              <input
                type="text"
                className="form-control"
                name="mobile"
                id="mobile"
                placeholder="eg. 6523360594"
                value={formData.mobile || ''}
                onChange={(e) => onChange(e)}
                required
              />
              <span style={{ color: colours.Red }}>{errors.mobile}</span>
            </div>
            <div className="row">
              <div className="col-lg-6 col-sm-12">
                <div className="form-group mt-4">
                  <Typography variant="h6">Prize Sent Date * (DD/MM/YYYY)</Typography>
                  <MaterialDatePicker minDate={false} label="" value={formData.prizeSentDate} onChange={(e) => onChangeDate(e, 'prizeSentDate')} />
                </div>
              </div>
              <div className="col-lg-6 col-sm-12">
                <div className="form-group mt-4">
                  <Typography variant="h6">Win Date * (DD/MM/YYYY)</Typography>
                  <MaterialDatePicker minDate={false} label="" value={formData.winDate} onChange={(e) => onChangeDate(e, 'winDate')} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-4 col-sm-12" />
          <div className="col-lg-2 col-sm-12">
            <div className="form-group">
              <input
                type="submit"
                className="btn btn-primary block"
                value={giveawayWinnerId ? 'Update' : 'Add'}
                onMouseDown={(e) => { e.preventDefault(); }}
              />
            </div>
          </div>
        </div>
      </form>
    </div>

  );
};

GiveawayWinnerAdd.propTypes = {
  match: PropTypes.shape({ params: PropTypes.shape({ id: PropTypes.string }) }),
};

GiveawayWinnerAdd.defaultProps = {
  match: {},
};

export default connect(null)(GiveawayWinnerAdd);
